<template>
  <div v-cloak>
    <transition name="fade" appear appear-active-class="fade-enter-active">

      <EditEmployeeComponent/>

    </transition>
  </div>
</template>

<script>

import EditEmployeeComponent from '@/components/employees/EditEmployeeComponent.vue'

export default {
  name: 'EditEmployee',
  components: {
    EditEmployeeComponent
  }
}
</script>

<style lang="scss">
@import "../styles/main.scss";
</style>

<style scoped lang="scss">
</style>
